/**
 * Category types used across settings, stores and shared components.
 * Moved to shared to avoid @rocksoft/shared depending on @era/stores.
 */

/**
 * Represents the different category types in the system.
 */
export type CategoryType = 'Brand' | 'Location' | 'Room' | 'Bar' | 'FrontDesk' | 'Housekeeping' | 'Kiosk' | 'Staff';

/**
 * Type guard to check if a string is a valid CategoryType
 */
export function isCategoryType(value: string): value is CategoryType {
  return ['Brand', 'Location', 'Room', 'Bar', 'FrontDesk', 'Housekeeping', 'Kiosk', 'Staff'].includes(value);
}
